import { createApi } from '@reduxjs/toolkit/query/react'
import { getCSRFToken } from '@view/utils/getCSRFToken'
import { baseApi } from './utils'

export const rentalReservationApi = createApi({
	reducerPath: 'rentalReservation',
	...baseApi('/rental/reservation/'),
	endpoints: builder => ({
		getRentalReservation: builder.query({
			query: rentalReservationId => ({
				url: `view.php?id=${rentalReservationId}`,
				headers: {
					'X-CSRF-Token': getCSRFToken(),
				},
			}),
		}),
	}),
})

export const { useGetRentalReservationQuery } = rentalReservationApi
